import React, { useContext } from 'react';

import { NotifyModal } from 'components';
import { DIALOG_KINDS } from 'constants/dialogKinds';
import { EmailContext, actionTypes } from 'containers/pages/Email/emailContext';

const RemoveDomainModal = props => {
  const { toggleModal, removeDomain, showModal, selectedDomain } = props;
  const { dispatch } = useContext(EmailContext);

  const removeDomainFromList = domain => {
    dispatch({
      type: actionTypes.REMOVE_DOMAIN,
      selectedDomain: domain,
    });
  };

  const modalConfirmText = 'Remove';
  const modalTitle = 'Remove Domain';

  const deleteDomain = () => {
    removeDomain(selectedDomain);
    toggleModal();
    removeDomainFromList(selectedDomain);
  };

  return (
    <NotifyModal
      title={modalTitle}
      confirmText={modalConfirmText}
      onCancel={toggleModal}
      onConfirm={deleteDomain}
      mode={DIALOG_KINDS.ERROR}
      open={showModal}
    >
      <div className="m-remove-domain-modal">
        <div className="m-remove-domain-modal__main">
          You will not be able to send emails using{' '}
          <span>{selectedDomain}</span> are you sure you want to remove it?
        </div>
      </div>
    </NotifyModal>
  );
};

export default RemoveDomainModal;
